// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.countries-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 20px;
  gap: 20px;
}

.country {
  border: 1px solid black;
  padding: 5px;
  position: relative;
  border-radius: 5px;
}
.country__flag {
  margin-right: 10px;
}
.country p {
  margin: 0;
}
.country__wrapper {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}
.country__favorite {
  position: absolute;
  bottom: 7px;
  right: 7px;
  border: 1px solid black;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  background-color: inherit;
  cursor: pointer;
  padding: 3px;
}
.country__favorite:hover {
  color: rgba(12, 122, 231, 0.4);
  border: 1px solid rgba(12, 122, 231, 0.4);
}
.country__favorite--active {
  color: rgb(253, 181, 181);
  border: 1px solid rgb(253, 181, 181);
}
.country__native {
  font-size: 14px;
  font-style: italic;
}
.country__currencies {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-left: 30px;
  display: grid;
  grid-template-columns: repeat(3, 45px);
}
.country__currency {
  margin-right: 5px;
  font-size: 15px;
}
.country__currency::after {
  content: "/";
  padding-left: 5px;
}
.country__currency:last-child {
  margin-right: 0;
}
.country__currency:last-child::after {
  content: "";
  padding-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/CountriesList/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EAAA,SAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,SAAA;AAAJ;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AAFJ;AAII;EACE,8BAAA;EACA,yCAAA;AAFN;AAKI;EACE,yBAAA;EACA,oCAAA;AAHN;AAOE;EACE,eAAA;EACA,kBAAA;AALJ;AAQE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,sCAAA;AANJ;AASE;EACE,iBAAA;EACA,eAAA;AAPJ;AASI;EACE,YAAA;EACA,iBAAA;AAPN;AAUI;EACE,eAAA;AARN;AAWI;EACE,WAAA;EACA,eAAA;AATN","sourcesContent":[".countries-list {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n}\n\n.country {\n  border: 1px solid black;\n  padding: 5px;\n  position: relative;\n  border-radius: 5px;\n\n  &__flag {\n    margin-right: 10px;\n  }\n\n  p {\n    margin: 0;\n  }\n\n  &__wrapper {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 10px;\n  }\n\n  &__favorite {\n    position: absolute;\n    bottom: 7px;\n    right: 7px;\n    border: 1px solid black;\n    border-radius: 50%;\n    width: 25px;\n    height: 25px;\n    background-color: inherit;\n    cursor: pointer;\n    padding: 3px;\n\n    &:hover {\n      color: rgba(12 122 231 / 0.4);\n      border: 1px solid rgba(12 122 231 / 0.4);\n    }\n\n    &--active {\n      color: rgb(253, 181, 181);\n      border: 1px solid rgb(253, 181, 181);\n    }\n  }\n\n  &__native {\n    font-size: 14px;\n    font-style: italic;\n  }\n\n  &__currencies {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin-left: 30px;\n    display: grid;\n    grid-template-columns: repeat(3, 45px);\n  }\n\n  &__currency {\n    margin-right: 5px;\n    font-size: 15px;\n\n    &::after {\n      content: \"/\";\n      padding-left: 5px;\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    &:last-child::after {\n      content: \"\";\n      padding-left: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
